import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import styled from 'styled-components';
import SwipeableViews from 'react-swipeable-views';
import ObserveSize from './ObserveSize';
import HouseCard from './HouseCard';
import { colorPalette, textStyles } from '../styles/styleGuide';
import { fromBreakpoint } from '../styles/breakpoints';
var HouseTypeCollection = /*#__PURE__*/function (_Component) {
  function HouseTypeCollection() {
    var _this;
    _classCallCheck(this, HouseTypeCollection);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, HouseTypeCollection, [].concat(args));
    _defineProperty(_this, "state", {
      renderWidth: 0
    });
    _defineProperty(_this, "renderHouseCard", function (_ref, index) {
      var availableCount = _ref.availableCount,
        bedrooms = _ref.bedrooms,
        energyLabel = _ref.energyLabel,
        isSold = _ref.isSold,
        livingSpace = _ref.livingSpace,
        media = _ref.media,
        optionCount = _ref.optionCount,
        price = _ref.price,
        slug = _ref.slug,
        totalCount = _ref.totalCount,
        variantName = _ref.variantName,
        variantCodes = _ref.variantCodes;
      return __jsx(HouseCard, {
        key: index,
        availableCount: availableCount,
        bedrooms: bedrooms,
        energyLabel: energyLabel,
        isSold: isSold,
        livingSpace: livingSpace,
        media: media,
        optionCount: optionCount,
        price: price,
        slug: slug,
        totalCount: totalCount,
        variantName: variantName,
        variantCodes: variantCodes,
        "data-id": "components_HouseTypeCollection_HouseCard"
      });
    });
    return _this;
  }
  _inherits(HouseTypeCollection, _Component);
  return _createClass(HouseTypeCollection, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props$houseType = this.props.houseTypes,
        houseTypes = _this$props$houseType === void 0 ? [] : _this$props$houseType;
      var swipeView = this.state.renderWidth < 480;
      return __jsx(HouseTypeBlock, {
        "data-e2e-block-housetypecollection": true,
        "data-id": "components_HouseTypeCollection_HouseTypeBlock"
      }, __jsx(ObserveSize, {
        observerFn: function observerFn(contentRect) {
          return _this2.setState({
            renderWidth: contentRect.width
          });
        },
        "data-id": "components_HouseTypeCollection_ObserveSize"
      }, houseTypes.map(function (houseType, index) {
        return __jsx("div", {
          key: index,
          "data-id": "components_HouseTypeCollection_div"
        }, __jsx(Title, {
          "data-id": "components_HouseTypeCollection_Title"
        }, houseType.typeName, " : ", houseType.typeUsp), swipeView ? __jsx(HouseCardRow, {
          swipeView: swipeView,
          "data-id": "components_HouseTypeCollection_HouseCardRow"
        }, __jsx(SwipeableViews, {
          enableMouseEvents: true,
          style: {
            overflow: 'visible',
            padding: '0',
            boxSizing: 'border-box'
          },
          slideStyle: {
            overflow: 'visible',
            padding: '0 5px',
            boxSizing: 'border-box'
          },
          "data-id": "components_HouseTypeCollection_SwipeableViews"
        }, houseType.houseVariants.map(function (house, index) {
          return _this2.renderHouseCard(house, index);
        }))) : __jsx(HouseCardRow, {
          "data-id": "components_HouseTypeCollection_HouseCardRow"
        }, houseType.houseVariants.map(function (house, index) {
          return _this2.renderHouseCard(house, index);
        })));
      })));
    }
  }]);
}(Component);
var Title = styled.h2(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin-top: 0;\n  margin-bottom: 35rem;\n"])), textStyles.sectionTitle, colorPalette.headerGrey);
var HouseCardRow = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  margin-bottom: 30rem;\n  display: flex;\n  box-sizing: border-box;\n  flex-flow: row wrap;\n  padding: 0;\n  position: relative;\n\n  ", ";\n\n  > div {\n    width: 100%;\n    margin-bottom: 20rem;\n\n    ", ";\n\n    ", ";\n  }\n\n  ", ";\n"])), fromBreakpoint.lg(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    padding: 0 0 5rem 0;\n  "]))), fromBreakpoint.md(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      height: auto;\n      width: calc( ((1/2) * 100%) - 10rem );\n\n      &:nth-of-type(2n + 1) {\n        margin-right: 20rem;\n      }\n    "]))), fromBreakpoint.lg(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      width: calc( ((1/3) * 100%) - 13.333rem );\n\n      &:nth-of-type(3n + 2) {\n        margin-right: 20rem;\n      }\n\n      &:nth-of-type(3n + 1) {\n        margin-right: 20rem;\n      }\n\n      &:nth-of-type(3n) {\n        margin-right: 0;\n      }\n    "]))), function (props) {
  return props.swipeView ? "\n  > div > div > div > div {\n    height: 100%;\n  }\n  " : "\n  > div > div > div > div {\n    height: auto;\n  }\n  ";
});
var HouseTypeBlock = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  margin-bottom: 40rem;\n"])));
export default HouseTypeCollection;